import {useTranslation} from '@aboutyou/i18n';
import {
  ContentPopper,
  ContentPopperProps,
  GenericIconName,
  Icon,
  SecondaryContentPopperButton,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface MovMoreInfoPopupProps {
  LayoutComponent: ContentPopperProps['LayoutComponent'];
  moreInfoIconText: string;
  moreInfoIconDescription: string;
  isOpen: boolean;
  onClose: () => void;
}

export const MovMoreInfoPopup = (props: MovMoreInfoPopupProps) => {
  const {
    LayoutComponent,
    moreInfoIconText,
    moreInfoIconDescription,
    isOpen,
    onClose,
  } = props;
  const {t} = useTranslation();
  return (
    <ContentPopper
      renderInPortal
      data-testid="shippingInfoPopup"
      LayoutComponent={LayoutComponent}
      headerContent={
        <HeaderContentWrapper data-testid="shippingInfoPopupHeader">
          <Icon size="XS" asset={GenericIconName.InfoFilledGray} />
          <Text data-testid="shippingInfoPopupText" weight="heavy" size="px16">
            {moreInfoIconText}
          </Text>
        </HeaderContentWrapper>
      }
      bodyContent={
        <div data-testid="shippingInfoPopupBody">
          <Text data-testid="shippingInfoPopupDescription">
            {moreInfoIconDescription}
          </Text>
        </div>
      }
      footerContent={
        <SecondaryContentPopperButton
          data-testid="closePopUpButton"
          label={t('Close')}
          onClick={onClose}
        />
      }
      open={isOpen}
      onClose={onClose}
    />
  );
};
const HeaderContentWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
`;
